module.exports = __webpack_public_path__ + "static/media/red-number-7.3318accf.png";